<template>
    <v-row style="margin: 30px 0 0;" justify="center">
        <v-col cols="12" sm="8" class="pa-0">
            <v-card class="text-center">
                <div class="d-flex flex-column justify-space-between align-center pa-4">
                    <v-img max-width="439" width="100%" src="img/mise-login.png" alt="Gestione Turni" contain></v-img>
                </div>
                <v-card-text class="text-left">
                    <h1 class="text-h3">Si è verificato un errore!</h1>
                    <p>Si è verificato un errore durante il caricamento. Prova a chiudere e riaprire l'app oppure a ricaricare la pagina. Se il problema persiste, scrivi a <a href="mailto:primisweb@misericordie.org">primisweb@misericordie.org</a></p>
                </v-card-text>
                <v-card-actions class="justify-center pb-4">
                    <v-btn color="primary" @click="refresh">
                        <v-icon left>mdi-refresh</v-icon>
                        Ricarica
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: 'Disabled',
    methods: {
        refresh() {
            window.location.href = '/' + window.location.search;
        }
    }
}
</script>

